import React, { useEffect, useState } from "react";
import { Menu, X, Dumbbell } from "lucide-react";
import { SITE } from "./siteData";

const LINKS = [
  { label: "Home", href: "#home" },
  { label: "Programs", href: "#programs" },
  { label: "Membership", href: "#membership" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-navigation"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-black/90 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-20">
        <a href="#home" className="flex items-center gap-3" data-testid="nav-logo">
          <img src={SITE.logo} alt="SVT Golden Fitness" className="h-12 w-12 object-contain" />
          <span className="font-bebas text-2xl tracking-wide text-white leading-none hidden sm:block">
            SVT GOLDEN <span className="text-gold">FITNESS</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm font-medium uppercase tracking-wider text-zinc-300 hover:text-gold transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="/login"
            data-testid="nav-staff-login"
            className="text-sm font-semibold uppercase tracking-wider text-zinc-300 hover:text-white transition-colors px-3"
          >
            Staff Login
          </a>
          <a
            href="#contact"
            data-testid="nav-join-btn"
            className="bg-gold hover:bg-gold_dark text-black font-bold uppercase tracking-wider text-sm px-6 py-3 rounded-md transition-all hover:scale-[1.03] flex items-center gap-2"
          >
            <Dumbbell size={16} /> Join Now
          </a>
        </div>

        <button
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-black/95 backdrop-blur-xl border-t border-white/10 px-6 py-6 space-y-4">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block text-base font-medium uppercase tracking-wider text-zinc-200 hover:text-gold"
            >
              {l.label}
            </a>
          ))}
          <a href="/login" className="block text-base font-medium uppercase tracking-wider text-zinc-200">
            Staff Login
          </a>
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="block text-center bg-gold text-black font-bold uppercase tracking-wider px-6 py-3 rounded-md"
          >
            Join Now
          </a>
        </div>
      )}
    </header>
  );
};
